var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-8"},[_c('span',{staticClass:"display-4 col-12"},[_vm._v(" "+_vm._s(_vm.$t("COMMON.PURCHASES_INVOICES"))+" ")])])]),_c('purchases-invoice-list-table',{attrs:{"filterPurchasesOrder":_vm.purchasesOrder.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }